import { Dialog, Theme } from '@material-ui/core';
import { withStyles, makeStyles, createStyles } from '@material-ui/styles';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_TEXT,
  DARKER_DIALOG_CONTENT_BACKGROUND,
  DARKER_ICON,
  ERROR_BUTTON_BACKGROUND,
  ERROR_DIALOG_BORDER,
  LIGHT_DIALOG_CONTENT_BACKGROUND,
  OFFWHITE_BUTTON_BACKGROUND,
  PLAIN_ICON,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BACKGROUND,
  PRIMARY_DIALOG_BACKGROUND,
  WARNING_BUTTON_BACKGROUND,
  WARNING_DIALOG_BORDER,
} = COLORS;

export const DefaultDialog = withStyles((theme: Theme) => ({
  paper: {
    backgroundColor: theme.palette.customBlack.main,
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${PRIMARY_DIALOG_BACKGROUND}`
        : `2px solid ${PRIMARY_DIALOG_BACKGROUND}`,
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '8px !important',
  },
}))(Dialog);

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      '&.paper': {
        minWidth: '85%',
        minHeight: '90%',
      },
      '& .MuiDialog-paperWidthSm': {
        maxWidth: '585px !important',
      },
    },
    dialogContent: {
      background: theme.palette.type === 'dark' ? DARKER_DIALOG_CONTENT_BACKGROUND : LIGHT_DIALOG_CONTENT_BACKGROUND,
    },
    errorDialog: {
      '& .MuiDialog-paper': {
        border: `solid 1px ${ERROR_DIALOG_BORDER}`,
      },
    },
    warningDialog: {
      '& .MuiDialog-paper': {
        border: `solid 1px ${WARNING_DIALOG_BORDER}`,
      },
    },
    closeIcon: {
      position: 'absolute',
      top: '20px',
      right: '20px',
      cursor: 'pointer',

      '& svg path': {
        fill: theme.palette.type === 'dark' ? PLAIN_ICON : DARKER_ICON,
      },
    },
    notifBody: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '40px 30px',
      '& svg': {
        width: '70px',
        height: '70px',
      },
      '& > *:not(:last-child)': {
        marginBottom: '40px',
      },
    },
    baseBtn: {
      height: '50px',
      transition: '0.3s',
      opacity: 1,

      '&:hover': {
        background: 'initial',
        opacity: 0.7,
      },
    },
    primaryBtn: {
      background: PRIMARY_BUTTON_BACKGROUND,
      color: PLAIN_TEXT,

      '&:hover': {
        background: PRIMARY_BUTTON_BACKGROUND,
      },
    },
    warningBtn: {
      background: WARNING_BUTTON_BACKGROUND,
      color: `${PLAIN_TEXT} !important`,

      '&:hover': {
        background: WARNING_BUTTON_BACKGROUND,
      },
    },
    errorBtn: {
      background: ERROR_BUTTON_BACKGROUND,
      color: `${PLAIN_TEXT} !important`,

      '&:hover': {
        background: ERROR_BUTTON_BACKGROUND,
      },
    },
    defaultBtn: {
      height: '50px',
      background: theme.palette.type === 'dark' ? DARK_BUTTON_BACKGROUND : OFFWHITE_BUTTON_BACKGROUND,
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
      transition: '0.3s',
      opacity: 1,

      '&:hover': {
        background: theme.palette.type === 'dark' ? DARK_BUTTON_BACKGROUND : OFFWHITE_BUTTON_BACKGROUND,
        opacity: 0.7,
      },
    },
  }),
);
